module.exports = __webpack_public_path__ + "img/2003.47a40c42.jpg";